module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-default-black.c499e5d9.png";